module.exports = __webpack_public_path__ + "static/media/ethermint.3244978e.svg";